import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getMotivosEstudiante } from "../../services/apis_estudiante";
import { actualizarMeson, eliminarMeson, actualizarFuncionario } from "../../services/apis_jefatura"

function EditarModuloModal({ show, onClose, modulo, onModulosChanged, onConfirmEliminar }) {
    const [nombreModulo, setNombreModulo] = useState(modulo?.nombre || "");
    const [numeroMeson, setNumeroMeson] = useState(modulo?.numero || "");
    const [motivosPosibles, setMotivosPosibles] = useState([]);
    const [motivosSeleccionados, setMotivosSeleccionados] = useState(modulo?.motivos || []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getMotivosEstudiante();
                setMotivosPosibles(data);

                // Si el módulo ya tiene uno asignado, precargarlo
                if (modulo?.motivos?.length > 0) {
                    const existentes = data.filter((m) =>
                    modulo.motivos.some((modMotivo) => modMotivo.id === m.id)
                    );
                    setMotivosSeleccionados(existentes);
                }
            } catch (err) {
                console.error("No se pudieron cargar los motivos", err);
            }
        };
        fetchData();
    }, [modulo]);

    const handleSave = async () => {
        // Seleccionar motivos es opcional; se pueden dejar vacíos

        const datosActualizados = {
            nombre: nombreModulo,
            numero: numeroMeson,
            motivos: motivosSeleccionados.map((motivo) => motivo.id)
        };

        try {
            await actualizarMeson(modulo.id, datosActualizados);
            console.log("Mesón actualizado correctamente");
            onClose();
            onModulosChanged?.();
        } catch (error) {
            console.error("Error al actualizar el mesón:", error);
            alert("Hubo un problema guardando los cambios");
        }
    };

    const handleDelete = async () => {
        onConfirmEliminar?.({
            id: modulo.id,
            nombre: modulo.nombre,
            onConfirm: async () => {
                try {
                    // Si hay un funcionario asignado, desasignarlo antes de eliminar
                    if (modulo.funcionario && modulo.funcionario.id) {
                        await actualizarFuncionario(modulo.funcionario.id, { meson: null });
                        console.log(`Funcionario ${modulo.funcionario.nombre} desasignado del módulo`);
                    }

                    await eliminarMeson(modulo.id);
                    console.log("Módulo eliminado correctamente");
                    onClose();
                    onModulosChanged?.();
                } catch (err) {
                    console.error("Error al eliminar el módulo:", err);
                    alert("Hubo un problema al eliminar el módulo");
                }
            }
        });
    };

    return (
        <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
            <Modal.Title>Editar Módulo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
            <Form.Group className="mb-3" controlId="formNombreModulo">
                        <Form.Label>Nombre del Módulo</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese nombre"
                            required
                            value={nombreModulo}
                            onChange={(e) => setNombreModulo(e.target.value)}
                        />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formNumeroMeson">
                <Form.Label>Número de Mesón</Form.Label>
                <Form.Control
                type="number"
                value={numeroMeson}
                onChange={(e) => setNumeroMeson(e.target.value)}
                min="1"
                max="10"
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formMotivos">
                <Form.Label>Motivos de Atención (opcional)</Form.Label>
                <div className="d-flex flex-wrap gap-2 mt-2">
                {motivosPosibles.map((motivo) => {
                    const isSelected = motivosSeleccionados.some(
                        (m) => m.id === motivo.id
                    );
                    return (
                    <span
                        key={motivo.id ?? motivo.nombre}
                        className="badge"
                        onClick={() => {
                            if (isSelected) {
                              // Quitar el motivo del array
                                setMotivosSeleccionados(
                                motivosSeleccionados.filter((m) => m.id !== motivo.id)
                                );
                            } else {
                              // Agregar el motivo al array
                                setMotivosSeleccionados([...motivosSeleccionados, motivo]);
                            }
                        }}
                        style={{
                            cursor: "pointer",
                            backgroundColor: isSelected ? "black" : "white",
                            color: isSelected ? "white" : "black",
                            border: "1px solid black",
                            borderRadius: "20px",
                            padding: "8px 14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                        }}
                    >
                        {isSelected && <i className="bi bi-check-lg"></i>}
                        {motivo.nombre}
                    </span>
                    );
                })}
                {motivosPosibles.length === 0 && (
                    <span style={{ color: "#666" }}>No hay motivos disponibles</span>
                )}
                </div>
            </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="danger" onClick={handleDelete}>
            Borrar Módulo
            </Button>
            <Button variant="secondary" onClick={onClose}>
            Cancelar
            </Button>
            <Button className="btn-accent" onClick={handleSave}>
            Guardar Cambios
            </Button>
        </Modal.Footer>
        </Modal>
    );
}

export default EditarModuloModal;